import React, { useState, useEffect, useRef } from "react";
import { Card } from "primereact/card";
import { FaEdit, FaPlusCircle, FaTrash, FaEye } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import CreateSubAccounts from "./SubAccounts/CreateSubAccount";
import { Toast } from "primereact/toast";
import SettingService from "../SettingService";
import EditSubAccount from "./SubAccounts/EditSubAccount";

type SubAccountProps = {
  onProjectView: (e: any) => void;
};

const SubAccount = (props: SubAccountProps) => {
  const toast = useRef<any>(null);

  const { t } = useTranslation();
  const [isCreateAccount, setIsCreateAccount] = useState<boolean>(false);
  const [isEditAccount, setIsEditAccount] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>("");
  const [keycloakId, setKeycloakId] = useState<string>("");
  const [users, setUsers] = useState<any>([]);
  const settingService = new SettingService();

  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };

  const checkStatus = (data: any) => {
    let projectDiv: any;
    let userDiv: any;
    if (data["projectRole"] == true) {
      projectDiv = <div className="status-green mr-5"></div>;
    } else {
      projectDiv = <div className="status-red mr-5"></div>;
    }

    if (data["userRole"] == true) {
      userDiv = <div className="status-green ml-4"></div>;
    } else {
      userDiv = <div className="status-red ml-4"></div>;
    }
    return [userDiv, projectDiv];
  };

  const deleteUser = (username: string, keycloak_id: string) => {
    settingService.deleteSubUser(username, keycloak_id).then((response) => {
      if (response == 200) {
        showSuccess("The user has been deleted!");
        getUsers();
      }
    });
  };

  const viewProjectPanel = (userId: number, projectRole: any) => {
    let div;

    if (projectRole) {
      div = (
        <>
          <FaEye
            className=" trash-icon"
            onClick={() => {
              props.onProjectView(userId);
            }}
          />
        </>
      );
    }

    return div;
  };

  const getUsers = () => {
    settingService.getSubUsers().then((response) => {
      setUsers(response);
    });
  };
  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <Card
        title={t("sub_account_permissions")}
        className="InputForms_container mt-4"
      >
        <div className="grid">
          <Toast ref={toast} />

          <div className="col-8">
            <div className="settings-text-cover">
              <span>{t("login_name")}</span>
              <span>{t("email")}</span>
              <span>{t("other_information_available")}</span>
            </div>
          </div>
          <div className="col-2">
            <div className="settings-text-cover">
              <div className="text-center">{t("permission")}</div>
            </div>
            <div className="add-edit flex justify-content-between mt-3">
              <p>
                {t("add_edit")} <br /> {t("users")}
              </p>
              <p>
                {t("add_edit")} <br /> {t("projects")}{" "}
              </p>
            </div>
          </div>
          <div className="col-2">
            <div className="settings-text-cover">
              <div className="text-center">{t("projects")}</div>
            </div>
          </div>
        </div>
        {users.map((data: any, i: any) => {
          return (
            <div className="grid row align-items-center" key={i}>
              <div className="col-8">
                <div className="name">
                  <p>
                    <span>{data["username"]}</span> |{" "}
                    <span>{data["email"]}</span> |{" "}
                    <span>{data["firstName"]}</span>{" "}
                    <span>{data["lastName"]}</span>{" "}
                  </p>
                </div>
              </div>
              <div className="col-2">
                <div className="status flex  justify-content-between">
                  {checkStatus(data)}
                </div>
              </div>
              <div className="col-2">
                <div className="status flex  ml-4">
                  <FaEdit
                    className="mx-3 edit-icon ml-2"
                    onClick={() => {
                      setKeycloakId(data["keycloak_id"]);
                      setUserName(data["username"]);
                      setIsEditAccount(true);
                    }}
                  />
                  {isEditAccount ? (
                    <EditSubAccount
                      username={userName}
                      keycloakId={keycloakId}
                      isEditAccount={isEditAccount}
                      onHide={() => {
                        setIsEditAccount(false);
                      }}
                      showSuccess={() => {
                        showSuccess("The user has been updated!");
                        getUsers();
                      }}
                    />
                  ) : (
                    <></>
                  )}
                  <FaTrash
                    className="mx-3 trash-icon"
                    onClick={() =>
                      deleteUser(data["username"], data["keycloak_id"])
                    }
                  />
                  {viewProjectPanel(data["id"], data["projectRole"])}
                </div>
              </div>
            </div>
          );
        })}
      </Card>

      {isCreateAccount ? (
        <>
          <CreateSubAccounts
            isCreateAccount={isCreateAccount}
            onHide={() => {
              setIsCreateAccount(false);
              getUsers();
            }}
            showSuccess={() => {
              showSuccess("The user has been created!");
            }}
          />
        </>
      ) : (
        <></>
      )}
      <div className="grid justify-content-end save-cover mt-4 pr-5">
        <div className="col-4 flex align-items-center">
          <div className="ml-auto mr-4">
            <FaPlusCircle
              fontSize={"20px"}
              color="green"
              className="add-user"
              onClick={() => {
                setIsCreateAccount(true);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAccount;
